module.exports = require('./helpers/bundle-url').getBundleURL('eeGpe') + "logo-dark.eefe0b7f.svg";